import type { ConfigType } from "@plone/registry";
import loadable from '@loadable/component';

export default function install(config: ConfigType) {
  // Language settings
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ["en"];
  config.settings.defaultLanguage = "en";

  // Volto 19 dropped these core loadables; volto-subblocks (used by
  // volto-form-block) still requests them. Re-register the copies already
  // installed via volto-subblocks so the Form block editor works.
  config.settings.loadables = {
    ...(config.settings.loadables ?? {}),
    reactDnd: loadable.lib(() => import('react-dnd')),
    reactDndHtml5Backend: loadable.lib(() => import('react-dnd-html5-backend')),
  };

  // Multi-level navigation (rendered by customizations/volto/.../Navigation/NavItem.jsx)
  config.settings.navDepth = 3;

  return config;
}
